import PropTypes from "prop-types";
import { Modal } from "@vds/modals";
import { Icon } from "@vds/icons";

import CreateAssetStep1 from "./create/step1";
import CreateAssetStep2 from "./create/step2";
import CreateAssetStep3 from "./create/step3";

import EditAssetStep1 from "./edit/step1";
import EditAssetStep2 from "./edit/step2";

import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/asset";
import AssetReview from "./review";


function FormAsset(props) {
  const {opHeaderText, formData, open, onExit } = props;
  
  const {opType, selectedAsset} = useSelector((state) => ({
    opType: state.asset.ui.opType,
    selectedAsset: state.asset.ui.selectedAsset,
  }));
  const dispatch = useDispatch();
  
  const handleBack = () => {
    if(opType === "selectProfile") {
      dispatch(updateUI({ opType: selectedAsset?.opType }));
      return;
    }
    dispatch(
      updateUI({
        formData: { ...formData, selectedStep: formData?.selectedStep - 1 },
      })
    );
  };
  
  return (
    <Modal
      opened={open}
      disableOutsideClick={true}
      ariaLabel={`title Modal`}
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      onClose={onExit}
      width={"736px"}
      closeButton={
        <>
          {formData && (opType === "selectProfile" || formData?.selectedStep > 1) && (
            <button
              style={{
                cursor: "pointer",
                position: "absolute",
                left: "15px",
                top: "15px",
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={handleBack}
            >
              <Icon name="left-arrow" />
            </button>
          )}
          <button
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "15px",
              top: "15px",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={onExit}
          >
            <Icon name="close" />
          </button>
        </>
      }
      {...props}
    >
      {/* Create form  start*/}
      {formData && opType === "create" && formData?.selectedStep === 1 && (
        <CreateAssetStep1 formData={formData} onExit={onExit} />
      )}
      {formData && opType === "create" && formData?.selectedStep === 2 && (
        <CreateAssetStep2 formData={formData} onExit={handleBack} />
      )}
      {formData && opType === "create" && formData?.selectedStep === 3 && (
        <CreateAssetStep3 formData={formData} onExit={handleBack} />
      )}
      {formData && opType === "create" && formData?.selectedStep === 4 && (
        <AssetReview opHeaderText={opHeaderText} formData={formData} onExit={handleBack} />
      )}
      {/* Create form  end*/}

      {/* Edit form start */}
      {formData && (opType === "edit" || opType === "clone") && formData?.selectedStep === 1 && (
        <EditAssetStep1 opType={opType} opHeaderText={opHeaderText} formData={formData} onExit={onExit} />
      )}
      {formData && opType === "selectProfile" && formData?.selectedStep === 1 && (
        <EditAssetStep2 opType={opType} opHeaderText={opHeaderText} formData={formData} onExit={handleBack} />
      )}
      {formData && (opType === "edit" || opType === "clone") && formData?.selectedStep === 2 && (
        <AssetReview opType={opType} opHeaderText={opHeaderText} formData={formData} onExit={handleBack} />
      )}
      {/* Edit form end */}
    </Modal>
  );
}

FormAsset.propTypes = {
  opHeaderText: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default FormAsset;
